// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Date$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as CustomActionMenu from "../../../../library/reuseable-components/CustomActionMenu.bs.js";
import * as CorePricingContext from "../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ModificationActions from "../../../../vm-mapper/ModificationActions.bs.js";
import * as ModificationActionManager from "../../../../library/ModificationActionManager.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var navigate_icon = PricingDashboardAssetsManager.getImage("navigate-icon.svg");

function getClassnameByStatus(status) {
  switch (status) {
    case /* Pending */1 :
        return "pending";
    case /* Scheduled */2 :
        return "scheduled";
    case /* Deactivated */0 :
    case /* Active */3 :
        return "active";
    
  }
}

function getImageSrcByAction(action) {
  switch (action) {
    case /* Deactivate */0 :
        return PricingDashboardAssetsManager.getImage("deactivate-icon.svg");
    case /* Delete */1 :
        return PricingDashboardAssetsManager.getImage("trash-icon.svg");
    case /* Approve */2 :
        return PricingDashboardAssetsManager.getImage("approve-icon.svg");
    case /* Discard */3 :
        return PricingDashboardAssetsManager.getImage("discard-icon.svg");
    
  }
}

function getMenuItems(external_id, actions, take_action_cb) {
  return List.map((function (action) {
                return {
                        text: ModificationActions.toString(action),
                        img_src: getImageSrcByAction(action),
                        action_cb: (function (param) {
                            return Curry._2(take_action_cb, external_id, action);
                          })
                      };
              }), actions);
}

function ModificationListItemView$ActionsMenu(Props) {
  var external_id = Props.external_id;
  var status = Props.status;
  var take_action_cb = Props.take_action_cb;
  var match = CorePricingContext.useContext(undefined);
  return React.createElement(CustomActionMenu.make, {
              items: getMenuItems(external_id, ModificationActionManager.getActionsByRoleAndStatus(match.role, status), take_action_cb)
            });
}

var ActionsMenu = {
  getImageSrcByAction: getImageSrcByAction,
  getMenuItems: getMenuItems,
  make: ModificationListItemView$ActionsMenu
};

function getActionTakenMessage(action) {
  switch (action) {
    case /* Deactivate */0 :
        return "Modification will be deactivated from tomorrow, " + Date$Catalyst.toString("Do MMMM", Date$Catalyst.tomorrow(undefined));
    case /* Delete */1 :
        return "Modification will be Deleted on submission";
    case /* Approve */2 :
        return "Modification will be updated from Pending to Scheduled";
    case /* Discard */3 :
        return "Modification will be Discarded on submission";
    
  }
}

function getModificationSummary(eligibility_rules) {
  var duration = Date$Catalyst.toString("HH:mm", eligibility_rules.start_time) + (" - " + Date$Catalyst.toString("HH:mm", eligibility_rules.end_time));
  return "Time: " + (duration + ("; Days: " + eligibility_rules.repeat_days));
}

function ModificationListItemView$ModificationSummary(Props) {
  var name = Props.name;
  var is_ab = Props.is_ab;
  var action_taken = Props.action_taken;
  var eligibility_rules = Props.eligibility_rules;
  var is_modification_expiring = Props.is_modification_expiring;
  return React.createElement("div", {
              className: "details"
            }, React.createElement(Row$Catalyst.make, {
                  children: React.createElement("div", {
                        className: "title"
                      }, name, is_ab ? React.createElement("span", {
                              className: "ab-modification-indicator"
                            }, "Experiment") : null, action_taken !== undefined ? React.createElement("span", {
                              className: "action-taken-message"
                            }, getActionTakenMessage(action_taken)) : (
                          is_modification_expiring ? React.createElement("span", {
                                  className: "action-taken-message"
                                }, "Modification is expiring tonight") : null
                        )),
                  className: "title-container"
                }), React.createElement("p", {
                  className: "change-summary"
                }, getModificationSummary(eligibility_rules)));
}

var ModificationSummary = {
  getActionTakenMessage: getActionTakenMessage,
  getModificationSummary: getModificationSummary,
  make: ModificationListItemView$ModificationSummary
};

function ModificationListItemView$ModificationPriority(Props) {
  var priority = Props.priority;
  return React.createElement("div", {
              className: "modification-priority"
            }, priority !== undefined ? React.createElement("div", {
                    className: "priority"
                  }, priority) : null);
}

var ModificationPriority = {
  make: ModificationListItemView$ModificationPriority
};

function isModificationExpiring(modification) {
  var match = modification.status;
  var match$1 = modification.end_date;
  if (match >= 3 && match$1 !== undefined) {
    return !Timestamp$Catalyst.isAfter(Caml_option.valFromOption(match$1), Timestamp$Catalyst.tomorrow(undefined));
  } else {
    return false;
  }
}

function ModificationListItemView(Props) {
  var modification = Props.modification;
  var open_modal = Props.open_modal;
  var action_taken = Props.action_taken;
  var take_action_cb = Props.take_action_cb;
  var is_prioritised = Props.is_prioritised;
  var priority = Props.priority;
  var is_core_pricing_pending = Props.is_core_pricing_pending;
  var is_action_taken = Belt_Option.isSome(action_taken);
  var is_modification_expiring = isModificationExpiring(modification);
  var match = CorePricingContext.useContext(undefined);
  var role = match.role;
  var match$1 = modification.base_details;
  var tmp;
  tmp = match$1.TAG === /* AB */0 ? true : false;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-modification-item"
            }, React.createElement(ModificationListItemView$ModificationPriority, {
                  priority: priority
                }), React.createElement("div", {
                  className: "details-container"
                }, React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "details-wrapper " + (getClassnameByStatus(modification.status) + (
                          is_action_taken ? " action-taken " : ""
                        ))
                    }, React.createElement("img", {
                          className: "navigate-icon",
                          src: navigate_icon,
                          onClick: (function (param) {
                              return Curry._1(open_modal, {
                                          TAG: /* ModificationDetails */0,
                                          modification: modification,
                                          take_action_cb: take_action_cb,
                                          is_action_allowed: ModificationActionManager.areActionsAllowed(role, is_prioritised, is_core_pricing_pending, action_taken, modification.status, modification.end_date)
                                        });
                            })
                        }), is_modification_expiring ? React.createElement("div", {
                            className: "expiring-indicator"
                          }) : null, React.createElement(Row$Catalyst.make, {
                          children: null,
                          className: "details-container"
                        }, React.createElement(ModificationListItemView$ModificationSummary, {
                              name: modification.name,
                              is_ab: tmp,
                              action_taken: action_taken,
                              eligibility_rules: modification.eligibility_rules,
                              is_modification_expiring: is_modification_expiring
                            }), ModificationActionManager.areActionsAllowed(role, is_prioritised, is_core_pricing_pending, action_taken, modification.status, modification.end_date) ? React.createElement(ModificationListItemView$ActionsMenu, {
                                external_id: modification.external_id,
                                status: modification.status,
                                take_action_cb: take_action_cb
                              }) : null))));
}

var make = ModificationListItemView;

export {
  navigate_icon ,
  getClassnameByStatus ,
  ActionsMenu ,
  ModificationSummary ,
  ModificationPriority ,
  isModificationExpiring ,
  make ,
  
}
/* navigate_icon Not a pure module */
